import { render, staticRenderFns } from "./AppChangelogDialog.vue?vue&type=template&id=4ec5855a&scoped=true"
import script from "./AppChangelogDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppChangelogDialog.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AppChangelogDialog.vue?vue&type=style&index=0&id=4ec5855a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec5855a",
  null
  
)

export default component.exports